import React from 'react';
import { Button } from '@mui/material';

export const HubspotDealLink = ({ dealId }: { dealId: string }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      href={`https://app.hubspot.com/contacts/9370913/record/0-3/${dealId}`}
      target="_blank"
      rel="noreferrer"
    >
      View Deal in Hubspot
    </Button>
  );
};
